import React, { useState, useEffect } from 'react';
import { Lucid, Blockfrost } from 'lucid-cardano';

const WalletSelection = () => {
  const [lucid, setLucid] = useState(null);
  const [availableWallets, setAvailableWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState('');
  const [walletAddress, setWalletAddress] = useState('');

  useEffect(() => {
    const initializeLucid = async () => {
      try {
        // Replace with your actual Blockfrost project ID.
        const lucidInstance = await Lucid.new(
          new Blockfrost("https://cardano-mainnet.blockfrost.io/api/v0", "mainnetehvvvJVoJUAz5DFJJz2L9fHZmkXlXTMP"),
          "Mainnet"
        );
        setLucid(lucidInstance);
        const supportedWallets = ['nami', 'eternl', 'typhon', 'vespr'];
        const detected = supportedWallets.filter(
          wallet => window.cardano && window.cardano[wallet] && window.cardano[wallet].enable
        );
        setAvailableWallets(detected);
      } catch (error) {
        console.error("Error initializing Lucid:", error);
      }
    };
    initializeLucid();
  }, []);

  // When a wallet button is clicked, immediately attempt to connect.
  const handleWalletSelect = async (walletName) => {
    setSelectedWallet(walletName);
    try {
      const api = await window.cardano[walletName].enable();
      // For Typhon wallet, polyfill getUsedAddresses if missing.
      if (walletName === "typhon" && typeof api.getUsedAddresses !== "function") {
        if (typeof api.getChangeAddress === "function") {
          api.getUsedAddresses = async () => {
            const addr = await api.getChangeAddress();
            return [addr];
          };
        } else {
          alert("Typhon wallet API does not support the required methods.");
          return;
        }
      }
      lucid.selectWallet(api);
      const addr = await lucid.wallet.address();
      setWalletAddress(addr);
    } catch (error) {
      console.error("Error connecting wallet:", error);
      alert("Failed to connect wallet: " + error.message);
    }
  };

  const mintAsset = async () => {
    if (!selectedWallet || !walletAddress) {
      alert("Please select and connect a wallet first.");
      return;
    }
    try {
      // Recipient address; update as needed
      const recipient = "addr1v96pxx6klmjar0u3q8eyp4mhsseju4mstha687exnq8mc0q54g8x2";
      // 10 ADA = 10,000,000 lovelace (1 ADA = 1,000,000 lovelace)
      const amount = 10000000n;

      // Build, sign, and submit the transaction using Lucid
      const tx = await lucid.newTx()
        .payToAddress(recipient, { lovelace: amount })
        .complete();
      const signedTx = await tx.sign().complete();
      const txHash = await signedTx.submit();

      alert("Transaction submitted! TX hash: " + txHash);
    } catch (error) {
      console.error("Minting failed:", error);
      alert("Transaction failed: " + (error.message || error.toString()));
    }
  };

  return (
    <div>
      <h3>Select Wallet:</h3>
      {availableWallets.length > 0 ? (
        availableWallets.map((wallet) => (
          <button
            key={wallet}
            className={selectedWallet === wallet ? 'wallet-btn active' : 'wallet-btn'}
            onClick={() => handleWalletSelect(wallet)}
          >
            {wallet.charAt(0).toUpperCase() + wallet.slice(1)}
          </button>
        ))
      ) : (
        <p>No supported wallets found.</p>
      )}
      {walletAddress && <p>Connected!</p>}
      <br />
      <button className="mint-button" onClick={mintAsset}>Mint</button>
    </div>
  );
};

export default WalletSelection;
